import React from 'react';
import PropTypes from 'prop-types';

import { Typography, Link } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import ArrowBackRoundedIcon from '@material-ui/icons/ArrowBackRounded';

const createStyles = theme => ({
  headerCard: {
    backgroundColor: theme.palette.primary.main,
    height: '4rem',
  },
  headerSubtitle: {
    marginLeft: '1rem',
    fontSize: '.75rem',
  },
});

function Help({ history }) {
  const theme = useTheme();
  const styles = React.useMemo(() => createStyles(theme), [theme]);

  return (
    <div className="container-fluid">
      <div className="row align-items-center" style={styles.headerCard}>
        <div className="pull-left align-middle" style={{ marginLeft: '1rem' }}>
          <Link href="/">
            <ArrowBackRoundedIcon
              style={{
                color: theme.palette.getContrastText(
                  styles.headerCard.backgroundColor,
                ),
              }}
              id="goHomeButton"
            />
          </Link>
        </div>
        <div
          className="pull-left align-middle text-white"
          style={styles.headerSubtitle}
        >
          Michelin&reg; OnCall 2.0
        </div>
        <div
          className="col text-center d-none d-md-block d-lg-block text-white"
          style={{ fontSize: '1.25rem' }}
        >
          ERS Event Viewer Summary
        </div>
      </div>
      <div className="row align-items-center" style={{ padding: '0.5rem' }}>
        <Typography>
          Fill in 2 of the 3 required fields:
          <br />
          The OnCall Case #, the unit #, and the ERS event date.
        </Typography>
      </div>
    </div>
  );
}

Help.propTypes = {
  history: PropTypes.shape({
    goBack: PropTypes.func,
  }).isRequired,
};

export default Help;
